import fieldName from './formFields';

const texts = {
  editExerciseTitle: 'Edit {exerciseType} exercise',
  newExerciseTitle: 'New Exercise',
  addExercise: 'Add New Exercise',
  editExercise: 'Edit Exercise',
  duplicateNameError: 'An exercise with the name {exerciseName} already exists',
  vimeoUploadError: 'Error in uploading video to Vimeo',
  videoUploadGuidelinesTitle: 'Video Upload Guidelines:',
  videoUploadGuidelines: [
    'File size: Less than 50 MB',
    'Aspect ratio: 9:16',
    'Video orientation: Portrait',
    'Length: Up to 3 minutes',
    'Video format: mp4 (audio supported)',
  ],
  exerciseUpdated: 'The exercise {exerciseName} has been saved successfully. {videoProcessing}',
  // eslint-disable-next-line max-len
  videoProcessing: 'The video has been sent for background processing. It may take a few minutes for it to appear properly in the exercise, workouts, and workout assignments.',
  uploading: 'Please wait until the exercise is uploaded...',
  errorSubmittingExercise: 'Error saving the exercise: {message}',
  createdNewTag: 'New tag created successfully',
  errorCreatingNewTag: 'Error creating new tag: {message}',
  validation: {
    requiredField: 'Required',
  },
  addNewButton: 'Add New Exercise',
  submitButton: 'Save Exercise',
  cancelButton: 'Cancel',
  revert: 'Revert to Original',
  createTag: 'Create new tag',
  labels: {
    video: 'Exercise Video',
    tags: 'Tags',
  },
  field: {
    [fieldName.NAME]: {
      label: 'Exercise Name',
    },
    [fieldName.DESCRIPTION]: {
      label: 'Exercise Description',
    },
  },
  exerciseId: 'Exercise ID',
};

export default texts;
